import { Component, OnInit } from "@angular/core";
import { BudgetWizardService } from "../services/budget.wizard.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { MenuService } from "src/app/services/menu.service";

@Component({
  selector: "app-budget-wizard",
  providers: [BudgetWizardService],
  templateUrl: "./budget-wizard.component.html",
  styleUrls: ["./budget-wizard.component.css"],
})
export class BudgetWizardComponent implements OnInit {
  loading = false;

  constructor(
    private menuService: MenuService,
    private service: BudgetWizardService,
  ) {
    this.menuService.setMenuTitle('Presupuesto', '');
  }

  async ngOnInit() {
    this.loading = true;
    await this.service.init();
    this.loading = false;
  }
}
